export const EVENTS = {
  PIANO_KEY_DOWN: 'piano-key-down',
  PIANO_KEY_UP: 'piano-key-up',
  COMPOSER_NOTE_ON: 'composer-note-on',
  COMPOSER_NOTE_OFF: 'composer-note-off',
  COMPOSER_STOPPED: 'composer-stopped',
}